import Visit from '../../visit';
import Select from '../../select/index';

// 撤销
async function addStackOut(stackOutItem: StackOutItem|null): Promise<void> {
    let delCubeIds: CubeId[] = stackOutItem.data;

    Visit.Remove.del(delCubeIds);
    Select.panelSelectAsync();
}

export {
    addStackOut
};
